// Builds a WhatsApp click-to-chat URL with a prefilled message
export const buildWhatsAppLink = (phoneWithCountryCode, message) => {
  const encoded = encodeURIComponent(message);
  return `https://wa.me/${phoneWithCountryCode}?text=${encoded}`;
};

export const productEnquiryMessage = (product) => {
  const price = product.discountPrice > 0 ? product.discountPrice : product.price;
  return `Namaste 🙏, I would like to enquire about this product:\n\n*${product.name}*\nPrice: ₹${price}\nCategory: ${product.category}\n\nPlease share more details / availability. Thank you!`;
};
